(function () {

  /* =========================================
     MASTER INITIALIZER
  ========================================= */

  function initAllSections(scope = document) {
    initCollectionLinks(scope);
    initDragScroll(scope);
    initCollectionFeatured(scope);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAllSections(document);
  });

  document.addEventListener("shopify:section:load", function (e) {
    if (e.target) {
      initAllSections(e.target);
    }
  });

  /* =========================================
     COLLECTION LINKS (Infinite Scroll Safe)
  ========================================= */

function initCollectionLinks(scope) {
  const scrollers = scope.querySelectorAll(".ccr-scroller:not([data-init])");

  scrollers.forEach(scroller => {
    scroller.dataset.init = "true";

    let isDragging = false;
    let startX = 0;
    let scrollStart = 0;

    scroller.addEventListener("pointerdown", (e) => {
      if (e.pointerType === "mouse" && e.button !== 0) return;

      isDragging = true;
      startX = e.clientX;
      scrollStart = scroller.scrollLeft;

      scroller.classList.add("dragging");
      scroller.setPointerCapture(e.pointerId);
    });

    scroller.addEventListener("pointermove", (e) => {
      if (!isDragging) return;

      const delta = e.clientX - startX;
      scroller.scrollLeft = scrollStart - delta;
    });

    function endDrag(e) {
      if (!isDragging) return;

      isDragging = false;
      scroller.classList.remove("dragging");

      try {
        scroller.releasePointerCapture(e.pointerId);
      } catch (err) {}
    }

    scroller.addEventListener("pointerup", endDrag);
    scroller.addEventListener("pointercancel", endDrag);

    scroller.querySelectorAll("img").forEach(img => {
      img.setAttribute("draggable", "false");
    });
  });
}
  /* =========================================
     DRAG SCROLL (Grid + Circles Unified)
  ========================================= */

  function initDragScroll(scope) {
  const scrollers = scope.querySelectorAll(
    ".custom-grid-circles__scroller:not([data-init])"
  );

  scrollers.forEach(scroller => {
    scroller.dataset.init = "true";

    let isDragging = false;
    let startX = 0;
    let scrollStart = 0;
    let moved = false;
    const dragThreshold = 6;

    scroller.addEventListener("pointerdown", (e) => {
      if (e.pointerType === "mouse" && e.button !== 0) return;

      isDragging = true;
      moved = false;
      startX = e.clientX;
      scrollStart = scroller.scrollLeft;

      scroller.classList.add("dragging");
    });

    scroller.addEventListener("pointermove", (e) => {
      if (!isDragging) return;

      const delta = e.clientX - startX;

      if (Math.abs(delta) > dragThreshold) {
        moved = true;
      }

      scroller.scrollLeft = scrollStart - delta;
    });

    scroller.addEventListener("pointerup", () => {
      isDragging = false;
      scroller.classList.remove("dragging");
    });

    scroller.addEventListener("pointerleave", () => {
      isDragging = false;
      scroller.classList.remove("dragging");
    });

    // ✅ FIXED CLICK HANDLING
    scroller.querySelectorAll("a").forEach(link => {
      link.addEventListener("click", (e) => {
        if (moved) {
          e.preventDefault();
        }
      });
    });

    // prevent image dragging ghost
    scroller.querySelectorAll("img").forEach(img => {
      img.setAttribute("draggable", "false");
    });
  });
}

  /* =========================================
     COLLECTION FEATURED
  ========================================= */

  function initCollectionFeatured(scope) {
    const sections = scope.querySelectorAll(".ccf-scroller:not([data-init])");

    sections.forEach(scroller => {
      scroller.dataset.init = "true";

      // Keep lightweight logic only
      // Avoid heavy resize calculations unless necessary

      let resizeTimer;
      window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          // Optional: add resize logic if needed
        }, 150);
      });
    });
  }

})();